import React from 'react'
import PropTypes from 'prop-types'
import { map, sortBy } from 'lodash'
import classNames from 'classnames'
import Topic from './topic'

// pregnancy and week-by-week topics should always display before trimester topic
// topics that don't appear below will display AFTER these topics
const SORTED_TOPIC_SLUGS = [
  'pregnancy',
  'week-by-week',
  'pregnancy-week-by-week',
]

const sortTopics = (topics) =>
  sortBy(topics, ({ slug }) =>
    [...SORTED_TOPIC_SLUGS].reverse().indexOf(slug)
  ).reverse()

const Topics = ({ topics, className }) => (
  <ul className={classNames('list-unstyled', className)}>
    {map(sortTopics(topics), (topic, idx) => (
      <Topic
        key={topic.slug}
        topic={topic}
        lastTopic={idx >= topics.length - 1}
      />
    ))}
  </ul>
)

Topics.propTypes = {
  topics: PropTypes.array,
  className: PropTypes.string,
}

export default Topics
